import { render, staticRenderFns } from "./CDOrganizationWheel.vue?vue&type=template&id=27e26b1b&scoped=true"
import script from "./CDOrganizationWheel.vue?vue&type=script&lang=ts"
export * from "./CDOrganizationWheel.vue?vue&type=script&lang=ts"
import style0 from "./CDOrganizationWheel.vue?vue&type=style&index=0&id=27e26b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e26b1b",
  null
  
)

export default component.exports